export interface NominatimPlace {
  name: string;
  shortLocation: string; // e.g. "Denver, Colorado"
}

export async function searchPlaces(query: string): Promise<NominatimPlace[]> {
  if (query.trim().length < 2) return [];
  const params = new URLSearchParams({
    q: query,
    format: "json",
    limit: "6",
    addressdetails: "1",
    dedupe: "1",
  });
  const res = await fetch(
    `https://nominatim.openstreetmap.org/search?${params}`,
    { headers: { Accept: "application/json" } }
  );
  if (!res.ok) return [];
  const data = await res.json();
  return (data as Record<string, unknown>[])
    .filter((r) => r.name)
    .map((r) => {
      const addr = (r.address ?? {}) as Record<string, string>;
      const city = addr.city ?? addr.town ?? addr.village ?? addr.municipality ?? "";
      const state = addr.state ?? addr.region ?? "";
      const country = addr.country_code?.toUpperCase() ?? "";
      const parts = [city, state !== city ? state : "", country]
        .filter(Boolean)
        .slice(0, 2)
        .join(", ");
      return { name: r.name as string, shortLocation: parts };
    });
}
